module.exports = "https://web-assets.ifttt.com/packs/media/premium_insights/download_icon-b249a44d.svg";